import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Link from '@components/Link/Link';

import './DocketsTable.scss';

const DocketsTable = ({
  docketsList,
  enableExport,
  onCheck,
  checkedDockets,
}) => (
  <div className="dockets-table">
    <Table>
      <TableHead>
        <TableRow className="dockets-table__header">
          {enableExport && (
            <TableCell />
          )}
          <TableCell>Name</TableCell>
          <TableCell numeric>Type</TableCell>
          <TableCell numeric>Docker Number</TableCell>
          <TableCell numeric>Date Filed</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {docketsList.map(docket => (
          <TableRow key={docket.id}>
            {enableExport && (
              <TableCell
                numeric
                className="dockets-table__checkbox"
                padding="checkbox"
              >
                <Checkbox
                  color="primary"
                  checked={checkedDockets.includes(docket.id)}
                  onChange={() => {
                    onCheck([docket.id]);
                  }}
                />
              </TableCell>
            )}
            <TableCell><Link href={docket.file} target="_blank">{docket.name}</Link></TableCell>
            <TableCell numeric>{docket.documentType}</TableCell>
            <TableCell numeric>{docket.docketNumber}</TableCell>
            <TableCell numeric>
              {docket.dateFiled && moment(docket.dateFiled).format('L')}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);

DocketsTable.propTypes = {
  docketsList: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.sting,
    file: PropTypes.sting,
    documentType: PropTypes.sting,
    docketNumber: PropTypes.sting,
    dateFiled: PropTypes.sting,
  })).isRequired,
  enableExport: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
  checkedDockets: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default DocketsTable;



// WEBPACK FOOTER //
// ./src/routes/Case/Dockets/components/DocketsTable/DocketsTable.js